import React from "react";
import BottomSheet from "../../../components/ui/BottomSheet";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/ui/Icon";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import { Body, IconBadge, Title, Message, Actions } from "./DeleteProductModal.styles";

interface DeleteProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteProductModal({
  isOpen,
  onClose,
  onConfirm,
}: DeleteProductModalProps) {
  const desktop = useIsDesktopViewport();

  return (
    <BottomSheet open={isOpen} onClose={onClose} centered={desktop} maxHeight="48%">
      <Body>
        <IconBadge>
          <Icon name="trash" size={24} strokeWidth={2} />
        </IconBadge>
        <Title>Remover Produto</Title>
        <Message>Deseja realmente remover o produto ?</Message>
        <Actions>
          <Button variant="ghost" full onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" full onClick={onConfirm}>
            Remover
          </Button>
        </Actions>
      </Body>
    </BottomSheet>
  );
}
